export enum ProjectPackagesCreateProjectType {
  Frontend = 'frontend',
  Backend = 'backend'
}
